package gr.tech.GRAttestation.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.silk.components.text.SpanText
import gr.tech.GRAttestation.models.storeusers.STORE_USER_INVITE_STATUS

@Composable
fun StoreUserInviteStatusBadge(
    inviteStatusBitwise: Short,
) {
    val status = STORE_USER_INVITE_STATUS.parseStatus(inviteStatusBitwise)

    SpanText(
        text = status.status,
        modifier = Modifier.classNames(
            "badge",
            when (status) {
                STORE_USER_INVITE_STATUS.PENDING   -> "text-bg-primary"
                STORE_USER_INVITE_STATUS.ACCEPTED  -> "text-bg-success"
                STORE_USER_INVITE_STATUS.CANCELLED -> "text-bg-secondary"
            }
        )
    )
}
